<div class="container d-flex justify-content-center">
  <div class="row w-100">
    <div class="col flex-column text-center">
      <h2>{{ "FORMS.RETAILER_PAYOUT.NEW_PAYOUT" | translate }}</h2>

      <app-retailer-payout-form></app-retailer-payout-form>
    </div>
  </div>
</div>
